import { motion } from "framer-motion";
import { useDispatch, useSelector } from "react-redux";
import { setLanguage } from "../store/features/languageSlice";

const LanguageToggleMobile = () => {
  const lang = useSelector((state) => state.language.lang);
  const dispatch = useDispatch();

  const isEN = lang === "en";

  return (
    <div className="relative flex items-center min-w-[74px]">
      <div
        className="
      relative
      flex
      items-center
      w-[74px]
      h-9
      rounded-full
      border border-gray-200
      overflow-hidden
      shadow-sm
    "
      >
        {/* Slider */}
        <motion.div
          layout
          transition={{
            type: "spring",
            stiffness: 400,
            damping: 30,
          }}
          className="
        absolute
        top-0
        h-[34px]
        w-[34px]
        rounded-full
        bg-white/50
      "
          style={{
            left: lang === "en" ? "0px" : "37px",
          }}
        />

        {/* EN */}
        <button
          onClick={() => dispatch(setLanguage("en"))}
          className="relative z-10 flex-1 flex justify-center"
        >
          <img
            src="/maria/uk.png"
            alt="English"
            className={`
          w-5 h-5 rounded-full object-cover
          transition-all duration-300
          ${lang !== "en" ? "grayscale opacity-60" : ""}
        `}
          />
        </button>

        {/* VI */}
        <button
          onClick={() => dispatch(setLanguage("vi"))}
          className="relative z-10 flex-1 flex justify-center"
        >
          <img
            src="/maria/vn.png"
            alt="Vietnamese"
            className={`
          w-5 h-5 rounded-full object-cover
          transition-all duration-300
          ${lang !== "vi" ? "grayscale opacity-60" : ""}
        `}
          />
        </button>
      </div>
    </div>
  );
};

export default LanguageToggleMobile;

// import { motion } from "framer-motion";
// import { useDispatch, useSelector } from "react-redux";
// import { setLanguage } from "../store/features/languageSlice";

// const LanguageToggleMobile = () => {
//   const lang = useSelector((state) => state.language.lang);
//   const dispatch = useDispatch();

//   const isEN = lang === "en";

//   return (
//     <div className="relative flex items-center border-0 border-gray-700 px-0 py-3 text-xs min-w-20 mr-3">
//       <div className="relative flex w-full max-w-[180px] rounded-full bg-none border border-gray-300 p-1 overflow-hidden">
//         {/* SLIDER */}
//         <motion.div
//           layout
//           transition={{
//             type: "spring",
//             stiffness: 400,
//             damping: 30,
//             mass: 0.6,
//           }}
//           className="absolute top-0 bottom-0 w-1/2 rounded-full bg-neonYellow shadow-[0_0_12px_rgba(230,255,26,0.6)]"
//           style={{
//             left: lang === "en" ? "0px" : "calc(50% + 0px)",
//           }}
//         />

//         {/* EN */}
//         <button
//           onClick={() => dispatch(setLanguage("en"))}
//           className="relative z-10 w-1/2 my-1 font-semibold"
//         >
//           <motion.span
//             animate={{ color: lang === "en" ? "#000" : "#9ca3af" }}
//             transition={{ duration: 0.25 }}
//             className={isEN ? "animate-neonFlicker" : ""}
//           >
//             E
//           </motion.span>
//         </button>

//         {/* VI */}
//         <button
//           onClick={() => dispatch(setLanguage("vi"))}
//           className="relative z-10 w-1/2 my-1 font-semibold"
//         >
//           <motion.span
//             animate={{ color: lang === "vi" ? "#000" : "#9ca3af" }}
//             transition={{ duration: 0.25 }}
//             className={!isEN ? "animate-neonFlicker" : ""}
//           >
//             V{" "}
//           </motion.span>
//         </button>
//       </div>
//     </div>
//   );
// };

// export default LanguageToggleMobile;
